<div
  class="faultAllocationContainer"
  *appHasPermission="{
    permissions: [permissions.allPermissions.FAULT_LIST_READ, permissions.allPermissions.FAULT_LIST_MAINT_READ],
  }"
>
  @if (timeoutManufacturers()) {
    <div class="widget grid-row-1-2 flex h-full justify-content-center align-items-center">
      <app-timeout></app-timeout>
    </div>
  } @else if (loadingManufacturers()) {
    <div class="widget grid-row-1-2 flex h-full justify-content-center align-items-center">
      <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
    </div>
  } @else {
    @if (manufacturers) {
      <ngx-simplebar [options]="{ autoHide: false }" class="list-wide-rows selectable widget grid-row-1-2">
        <div class="list-grid">
          <div class="flex justify-content-between align-items-center">
            <span class="list-header">{{ "fault_allocation.controller_catalog.manufacturers" | translate }}</span>

            <app-svg-icon
              *appHasPermission="{
                permissions: [permissions.allPermissions.FAULT_LIST_MAINT_CREATE],
              }"
              iconName="plus"
              iconColor="primary"
              class="pointer"
              style="margin-bottom: 0.5rem"
              (click)="onAddClick(controllerCatalogTypes.MANUFACTURER)"
            >
            </app-svg-icon>
          </div>

          @for (manufacturer of manufacturers; track manufacturer.id) {
            <div
              class="list-item"
              [ngClass]="{
                selected: manufacturer.selected,
                'selected-bg': manufacturer.selected,
              }"
              (click)="selectManufacturer(manufacturer)"
            >
              <div #item class="list-item-content">
                <span>{{ manufacturer.label }}</span>

                <div class="btn-container">
                  <app-svg-icon
                    *appHasPermission="{
                      permissions: [permissions.allPermissions.FAULT_LIST_MAINT_UPDATE],
                    }"
                    [id]="'editManufacturer' + manufacturer.id"
                    iconName="edit"
                    iconColor="primary"
                    iconSize="xs"
                    (click)="onEditClick(controllerCatalogTypes.MANUFACTURER, manufacturer, $event)"
                  ></app-svg-icon>

                  <app-svg-icon
                    *appHasPermission="{
                      permissions: [permissions.allPermissions.FAULT_LIST_MAINT_DELETE],
                    }"
                    iconName="trash"
                    iconColor="primary"
                    [id]="'deleteManufacturer' + manufacturer.id"
                    iconSize="xs"
                    (click)="onDeleteClick(controllerCatalogTypes.MANUFACTURER, manufacturer, $event)"
                  ></app-svg-icon>
                </div>
              </div>
            </div>
            @if (manufacturer.selected) {
              <div class="selected-arrow selected-bg">
                <app-svg-icon iconName="arrow_right" iconColor="secondary" iconSize="xs"></app-svg-icon>
              </div>
            }
          }
        </div>
      </ngx-simplebar>
    }
  }
  @if (timeoutModels()) {
    <div class="widget grid-row-1-2 flex h-full justify-content-center align-items-center">
      <app-timeout></app-timeout>
    </div>
  } @else if (loadingModels()) {
    <div class="widget grid-row-1-2 flex h-full justify-content-center align-items-center">
      <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
    </div>
  } @else {
    @if (models) {
      <ngx-simplebar [options]="{ autoHide: false }" class="list-wide-rows grid-row-1-2 widget">
        <div class="list-grid">
          <div class="flex justify-content-between align-items-center">
            <span class="list-header">{{ "fault_allocation.controller_catalog.models" | translate }}</span>

            <app-svg-icon
              *appHasPermission="{
                permissions: [permissions.allPermissions.FAULT_LIST_MAINT_CREATE],
              }"
              iconName="plus"
              iconColor="primary"
              class="pointer"
              style="margin-bottom: 0.5rem"
              (click)="onAddClick(controllerCatalogTypes.MODEL)"
            >
            </app-svg-icon>
          </div>
          @for (model of models; track model.id) {
            <div class="list-item">
              <div class="list-item-content">
                <div class="text-container">
                  <span>{{ model.label }}</span>
                  <div class="link-container">
                    <app-svg-icon
                      iconName="link-chain"
                      [iconColor]="model.faultList ? 'primary' : 'secondary'"
                      iconSize="xs"
                    >
                    </app-svg-icon>
                    @if (model.faultList) {
                      <span class="existent link">
                        {{ model.faultList.label }}
                      </span>
                    } @else {
                      <span class="non-existend link">
                        {{ "fault_allocation.controller_catalog.create_link" | translate }}
                      </span>
                    }
                  </div>
                </div>

                <div class="btn-container">
                  <app-svg-icon
                    *appHasPermission="{
                      permissions: [permissions.allPermissions.FAULT_LIST_MAINT_UPDATE],
                    }"
                    iconName="edit"
                    iconColor="primary"
                    iconSize="xs"
                    (click)="onEditClick(controllerCatalogTypes.MODEL, model, $event)"
                  ></app-svg-icon>

                  <app-svg-icon
                    *appHasPermission="{
                      permissions: [permissions.allPermissions.FAULT_LIST_MAINT_DELETE],
                    }"
                    iconName="trash"
                    iconColor="primary"
                    iconSize="xs"
                    (click)="onDeleteClick(controllerCatalogTypes.MODEL, model, $event)"
                  ></app-svg-icon>
                </div>
              </div>
            </div>
          }
        </div>
      </ngx-simplebar>
    }
  }

  @if (timeoutFaultLists()) {
    <div class="widget flex h-full justify-content-center align-items-center">
      <app-timeout></app-timeout>
    </div>
  } @else if (loadingFaultLists()) {
    <div class="widget flex h-full justify-content-center align-items-center">
      <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
    </div>
  } @else {
    <ngx-simplebar [options]="{ autoHide: false }" class="widget faultLists">
      <div class="list-compact-rows selectable">
        <span class="listTitle">
          {{ "fault_allocation.fault_lists.fault_list_title" | translate }}
        </span>
        <div class="listItems">
          @for (faultList of faultLists; track faultList.id) {
            <div
              class="listRow"
              [ngClass]="{
                selected: faultList.id === selectedFaultList()?.id,
              }"
              (click)="selectFaultList(faultList)"
            >
              <span>{{ faultList.label }}</span>

              <div class="actionButtonGroup">
                <app-svg-icon
                  *appHasPermission="{
                    permissions: [permissions.allPermissions.FAULT_LIST_UPDATE],
                  }"
                  (click)="onEditFaultList($event, faultList)"
                  iconName="edit"
                  iconColor="primary"
                  iconSize="xs"
                ></app-svg-icon>

                <app-svg-icon
                  *appHasPermission="{
                    permissions: [permissions.allPermissions.FAULT_LIST_DELETE],
                  }"
                  (click)="onDeleteFaultList($event, faultList)"
                  iconName="trash"
                  iconColor="primary"
                  iconSize="xs"
                ></app-svg-icon>
              </div>
            </div>
          }
        </div>
        <div class="flex justify-content-between mt-3">
          <app-button
            *appHasPermission="{
              permissions: [permissions.allPermissions.FAULT_LIST_CREATE],
            }"
            class="add-btn pointer"
            buttonText="fault_allocation.fault_lists.add_fault_list"
            (click)="onAddFaultList()"
          ></app-button>
          @if (role === "SYS_ADMIN") {
            <app-button class="pointer" buttonText="Sprachen verwalten" (click)="onLanguageManagement()"></app-button>
          }
        </div>
      </div>
    </ngx-simplebar>
  }
  @if (selectedFaultList()) {
    <div class="widget faults p-3">
      <span style="margin-left: 1rem">{{ selectedFaultList()!.label }}</span>
      @if (selectedFaultList()!.faults && selectedFaultList()!.faults!.length > 0) {
        <p-table
          [scrollable]="true"
          class="tableHeaderAlignTop fullTable"
          [columns]="faultsCols"
          [value]="selectedFaultList()!.faults!"
        >
          <ng-template #header let-columns>
            <tr>
              @for (col of columns; track col) {
                <th class="font-size-sm font-normal" [pSortableColumn]="col.field">
                  {{ col.header | translate }}
                  <p-sortIcon [field]="col.field" />
                </th>
              }
              <th></th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template #body let-rowData let-columns="columns">
            <tr>
              @for (col of columns; track col) {
                @if (col.field === "fixLink") {
                  <td class="pointer" (click)="openFixLink(rowData[col.field])">
                    {{ rowData[col.field] | translate }}
                  </td>
                } @else {
                  <td>{{ rowData[col.field] | translate }}</td>
                }
              }
              <td>
                @if (rowData.isEditable === true) {
                  <app-svg-icon
                    *appHasPermission="{
                      permissions: [permissions.allPermissions.FAULT_LIST_UPDATE],
                    }"
                    class="pointer"
                    [attr.data-testid]="'edit-fault-' + rowData.id"
                    iconName="edit"
                    iconColor="primary"
                    iconSize="xs"
                    (click)="onEditFault(rowData)"
                  ></app-svg-icon>
                }
              </td>

              <td>
                @if (rowData.isEditable === true) {
                  <app-svg-icon
                    *appHasPermission="{
                      permissions: [permissions.allPermissions.FAULT_LIST_DELETE],
                    }"
                    class="pointer"
                    [attr.data-testid]="'delete-fault-' + rowData.id"
                    iconName="trash"
                    iconColor="primary"
                    iconSize="xs"
                    (click)="onDeleteFault($event, rowData)"
                  ></app-svg-icon>
                }
              </td>
            </tr>
          </ng-template>
        </p-table>
      } @else {
        <span class="no-entries">{{ "common.no_entries" | translate }}</span>
      }
      <app-button
        *appHasPermission="{
          permissions: [permissions.allPermissions.FAULT_LIST_CREATE],
        }"
        (click)="onAddFault()"
        buttonText="fault_allocation.fault_lists.faults.add"
      ></app-button>
    </div>
  }
</div>
